import {Client, DEVICES, BADGE, PROJECTS, BUILDING} from "../../service/Client";
import {clearCreator, getStatusCreator, loading, success, error} from "./badgeActionsCreator";

const BADGES = 'badges'
const BUILDINGS = 'buildings'
const CARDS = 'cards'

let client = new Client();

export function clearAction() {
	return dispatch => { dispatch(clearCreator()) }
}

export function getStatus(projectId) {
	return async dispatch => {
		try {
			dispatch(loading(true));
			let results = await Promise.all([
				client.get(`${BADGE}/project/${projectId}/${BADGES}`),
				client.get(`${BADGE}/project/${projectId}/${BUILDINGS}`),
				client.get(`${BADGE}/project/${projectId}/${CARDS}`)
			])
			dispatch(getStatusCreator({
				badges: results[0].data,
				buildings: results[1].data,
				cards: results[2].data
			}))
		}
		catch (e) {
			manageError(e, dispatch)
		}
	}
}

export function updateProjectBadges(projectId, devices) {
	return dispatch => client.update(`${PROJECTS}/${projectId}/${DEVICES}`, {body: devices})
		.then(() => dispatch(getStatus(projectId)))
		.catch(e => manageError(e,dispatch))
}

export function changeBadgeLabel(projectId, deviceId, label) {
	return dispatch => client
		.update(`${BADGE}/project/${projectId}/badges/${deviceId}/label`, {body:label, headers:{"Content-Type":"text/plain"}})
		.then(() => dispatch(getStatus(projectId)))
		.catch(e => manageError(e,dispatch));
}

export function changeCardLabel(projectId, cardId, label) {
	return dispatch => client
		.update(`${BADGE}/project/${projectId}/cards/${cardId}/label`, {body:label, headers:{"Content-Type":"text/plain"}})
		.then(() => dispatch(getStatus(projectId)))
		.catch(e => manageError(e,dispatch));
}

export function saveBuilding(projectId, building) {
	return dispatch => {
		if(building.id) {
			Promise.all([
				client.update(`${BADGE}/project/${projectId}/${BUILDING}`, {body:building, elem:building.id}),
				client.update(`${BADGE}/project/${projectId}/${BUILDING}/${building.id}/${BADGES}`, {body: building.devices})
			]).then(() =>{
				dispatch(success());
				dispatch(getStatus(projectId));
			}).catch( e => manageError(e,dispatch))
		} else {
			client.post(`${BADGE}/project/${projectId}/${BUILDING}`, {body:building}).then(() =>{
				dispatch(success());
				dispatch(getStatus(projectId));
			}).catch( e => manageError(e,dispatch))
		}
	}
}

export function updateBuildingBadges(projectId, buildingId, devices) {
	return dispatch => {
			client.update(`${BADGE}/project/${projectId}/${BUILDING}/${buildingId}/${BADGES}`, {body: devices}).then(() =>{
				dispatch(success())
				dispatch(getStatus(projectId))
			}).catch( e => manageError(e,dispatch))
		}
}

export function disassociateBuilding(projectId, buildingId) {
	return dispatch => {
			client.delete(`${BADGE}/project/${projectId}/${BUILDINGS}`, {elem: buildingId}).then(() =>{
				dispatch(success())
				dispatch(getStatus(projectId))
			}).catch( e => manageError(e,dispatch))
		}
}

export function disassociateCard(projectId, cardId) {
	return dispatch => {
			client.delete(`${BADGE}/project/${projectId}/${CARDS}`, {elem: cardId}).then(() =>{
				dispatch(success())
				dispatch(getStatus(projectId))
			}).catch( e => manageError(e,dispatch))
		}
}

function manageError(e, dispatch) {
	dispatch(loading(false));
	if (e.response) {
		// The request was made and the server responded with a status code
		// that falls out of the range of 2xx
		dispatch(error(e.response.data.message));
	} else {
		// Something happened in setting up the request that triggered an Error
		console.log('Error', e.message);
		dispatch(error(e.message));
	}
}
